
import React, { useEffect } from 'react';
import routes from 'lib/routes';
import useAuthenticate from 'hooks/useAuthenticate';
import useIsMountedRef from 'hooks/useIsMountedRef';

export default function Home({ history }) {
    const [user] = useAuthenticate();
    const isMoutedRef = useIsMountedRef();
    useEffect(() => {
        if (!isMoutedRef.current) { return; }
        if (user) {
            //history.push(routes.dashboardFront);
            window.location.href = routes.dashboardFront;
        }
        else {
            //history.push(routes.login);
            window.location.href = routes.login;
        }
    }, [user, isMoutedRef, history]);
    return (<div className="p-3">Loading contents...</div>);
}

